/** App version policy (ADR-0007): block below minimum, nudge below latest. */

export function compareVersions(a: string, b: string): number {
  const pa = a.split(/[.+-]/).map((x) => parseInt(x, 10) || 0);
  const pb = b.split(/[.+-]/).map((x) => parseInt(x, 10) || 0);
  for (let i = 0; i < 3; i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d !== 0) return Math.sign(d);
  }
  return 0;
}

export interface VersionPolicy {
  minimum: string;
  latest: string;
  androidApkUrl: string | null;
}

export type VersionStatus = 'ok' | 'update-available' | 'update-required';

export function versionStatus(current: string, policy: VersionPolicy): VersionStatus {
  if (compareVersions(current, policy.minimum) < 0) return 'update-required';
  if (compareVersions(current, policy.latest) < 0) return 'update-available';
  return 'ok';
}
